<template>
  <div class="bg">
      <div class="header">
          <div class="han">焦点新闻</div>
          <div class="eng">Focus News</div>
      </div>
      <div class="body">
        <div class="sponser" >
          <img class="sponser-img" src="../../../assets/sportsLogo/focusNewbg.png" alt="">
        </div>
      </div>
  </div>
</template>

<script>
// import moment from 'moment'
export default {
  components: {},
  data () {
    return {
      imgList: [
        {id: 1, img: 'http://static.daoba.com/data/attachment/album//20190426/1556276792.jpeg'},
        {id: 2, img: 'http://static.daoba.com/data/attachment/album//20190422/1555942956.jpeg'},
        {id: 3, img: 'http://static.daoba.com//654211558886.jpg'},
        {id: 4, img: 'http://static.daoba.com/data/attachment/album//20190424/1556090233.jpeg'},
        {id: 5, img: 'http://static.daoba.com/data/attachment/album//20190423/1555979808.jpeg'},
        {id: 6, img: 'http://static.daoba.com/data/attachment/album//20180919/1537360388.jpeg'},
        {id: 7, img: 'http://static.daoba.com//593571639469'},
        {id: 8, img: 'http://static.daoba.com//377500496311'}
      ]
    }
  },
  created () {
    window.scrollTo(0, 0)
    // this.setDefaultMonth()
    // this.loadData()
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.bg {
  width: 1200px;
  margin: 90px auto;
  // padding-top: 100px;
  // background-color: #FFF;
  // background-color: red;
}
.header{
  height: 31px;
  color: #333;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  // margin-bottom: 47px;
}
.han{
  font-size: 30px;
  margin-right: 10px;
  font-weight: bold ;
}
.eng{
  font-size: 20px;
}
.body{
  width: 100%;
  padding-top: 100px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  // background-color: green;
  // justify-content: space-around;
}
.sponser{
  width: 100%;
  height: 1130px;
  margin-right: 60px;
  margin-bottom: 60px;
}
.sponser-img{
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/news/FocusNews.vue